var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseAside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_42)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35305 9.70859C4.55305 9.89859 4.80305 9.99859 5.06305 9.99859L5.05305 9.97859C5.31305 9.97859 5.56305 9.88859 5.76305 9.68859C6.15305 9.29859 6.15305 8.66859 5.76305 8.27859L2.47305 4.98859L5.76305 1.69859C6.15305 1.30859 6.15305 0.678594 5.76305 0.288594C5.37305 -0.101406 4.74305 -0.101406 4.35305 0.288594L0.353047 4.29859C-0.0369531 4.68859 -0.0369531 5.31859 0.353047 5.70859L4.35305 9.70859ZM9.35305 9.70859C9.55305 9.89859 9.80305 9.99859 10.063 9.99859L10.053 9.97859C10.313 9.97859 10.563 9.88859 10.763 9.68859C11.153 9.29859 11.153 8.66859 10.763 8.27859L7.47305 4.98859L10.763 1.69859C11.153 1.30859 11.153 0.678594 10.763 0.288594C10.373 -0.101406 9.74305 -0.101406 9.35305 0.288594L5.35305 4.29859C4.96305 4.68859 4.96305 5.31859 5.35305 5.70859L9.35305 9.70859Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    fill: "white",
    transform: "translate(0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseAside);
export default __webpack_public_path__ + "static/media/icon-close-aside.07f6ff6e24cd47658c2b98ace7379311.svg";
export { ForwardRef as ReactComponent };